{
    "raporsatis": {
        "Baslik": "Verkooprapport",
        "Tarih": "Datum",
        "Musteri": "Verzekerde",
        "Urun": "Product",
        "Tutar": "Bedrag",
        "Kullanici": "Gebruiker",
        "Durum": "Status",
        "PoliceNo": "Polisnr",
        "Aciklama": "Notitie",
        "IptalTarihi": "Annulatiedatum",
        "Kur": "Koers",
        "Onayli": "Goedgekeurd",
        "Onaysiz": "Niet goedgekeurd",
        "Iptal": "Geannuleerd",
        "Cayma": "Herroeping",
        "Toplam": "Totaal",
        "Adet": "Aantal",
        "Arama": "Zoeken",
        "Ara": "Zoeken",
        "Kapat": "Sluiten",
        "Temizle": "Wissen",
        "BaslangicTarihi": "Begindatum",
        "BitisTarihi": "Einddatum",
        "SatisTipi": "Verkooptype",
        "OdemeSekli": "Betalingsmethode",
        "Kapsam": "Bereik",
        "Takim": "Team",
        "Sube": "Filiaal",
        "Istatistikler": "Statistieken",
        "OzetGosterge": "Overzicht Dashboard",
        "ToplamSatisAdedi": "Totaal Aantal Verkoop",
        "ToplamLira": "TL Bedrag",
        "ToplamDolar": "Dollar Bedrag",
        "ToplamAPE": "APE Bedrag",
        "OnayOrani": "Goedkeuringspercentage",
        "Bekliyor": "In afwachting",
        "Basari": "Succes",
        "Duzenle": "Bewerken",
        "SigortaEttiren": "Verzekerde",
        "Kaydet": "Opslaan",
        "Sil": "Verwijderen",
        "SilmeOnayi": "Verwijdering Bevestigen",
        "SilmeMesaji": "Weet u zeker ki wilt dit record verwijderen?",
        "GeriAlOnayi": "Herstel Bevestiging",
        "GeriAlMesaji": "Weet u zeker dat u deze geannuleerde verkoop wilt herstellen?",
        "DurumOnayi": "Statuswijziging Bevestigen",
        "DurumMesaji": "Weet u zeker dat u de status van deze verkoop wilt wijzigen?",
        "Evet": "Ja",
        "Kendi": "Eigen",
        "Tam": "Volledig",
        "Hepsi": "Alle",
        "Yeni": "Nieuw",
        "Yenileme": "Verlenging",
        "EkBelge": "Aanhangsel",
        "Pesin": "Contant",
        "Taksitli": "In termijnen",
        "KrediKarti": "Creditcard",
        "PoliceNoPlaceholder": "Voer polisnummer in",
        "AciklamaPlaceholder": "Voeg een notitie toe...",
        "Network": "Netwerk",
        "Sağlık": "Gezondheid",
        "Doğum": "Geboorte",
        "AktarimTutar": "Overdrachtsbedrag (₺)",
        "KalanGunRaporu": "Rapport Resterende Dagen",
        "KullaniciListesi": "Gebruikerslijst",
        "IptalTarihiSecin": "Selecteer Annuleringsdatum",
        "TarihSecin": "Selecteer datum",
        "Tamam": "OK",
        "IptalGir": "Voer Annulering in",
        "IptalSil": "Verwijder Annulering"
    }
}
